import { clientTypes } from "../../type/clientTypes";

const initialState = {
  count: {
    isLoading: false,
    data: [],
    msg: "",
  },
  pieChart: {
    isLoading: false,
    data: [],
    msg: "",
  },
  podcastListeners: {
    isLoading: false,
    data: [],
    msg: "",
  },
  podcastCategoryWise: {
    isLoading: false,
    data: [],
    msg: "",
  },
  top10Listeners: {
    isLoading: false,
    data: [],
    msg: "",
  },
  top100MostListened: {
    isLoading: false,
    data: [],
    msg: "",
  },
  top100LeastListened: {
    isLoading: false,
    data: [],
    msg: "",
  },
};

export const dashboardDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case clientTypes.DASHBOARD_DATA_PENDING:
      return {
        ...state,
        [action.key]: {
          ...(state[action.key] || {}),
          isLoading: true,
          msg: "",
        },
      };

    case clientTypes.DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        [action.key]: {
          isLoading: false,
          data: action.payload,
          msg: action.msg,
        },
      };

    case clientTypes.DASHBOARD_DATA_FAILED:
      return {
        ...state,
        [action.key]: {
          isLoading: false,
          data: [],
          msg: action.msg,
        },
      };

    default:
      return state;
  }
};
